import { useSelector } from 'react-redux';
import { summerSale2026SidebarBanner } from 'reactApp/appHelpers/featuresHelpers/features/summerPromo2026';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';

export const useSummerSale2026Banner = () => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isOverquota = useSelector(UserQuotaSelectors.isOverquota);

    return summerSale2026SidebarBanner && !isPaidUser && !isBizUser && !isOverquota;
};
